export default __webpack_public_path__ + "static/media/seleced-files-1.6c602e0f.png";